import { archiveChat, unarchiveChat } from "@/lib/api";
import { withLoadingToast } from "@/lib/loading-toast";
import { useChatStore } from "@/stores/useChatStore";
import { useToastStore } from "@/stores/useToastStore";

/**
 * 1 件ずつ確定させ、途中で失敗しても成功済みの分は一覧に反映したまま、
 * 何件まで済んだかをトーストで伝えて例外を投げ直す。複数件は進み具合を進行中トーストで出す。
 */
export async function setChatsArchived(
	chatIds: readonly string[],
	archived: boolean,
): Promise<void> {
	const action = archived ? "アーカイブ" : "アーカイブ解除";
	const store = useChatStore.getState();
	let done = 0;
	const archiveEach = async (update?: (message: string) => void) => {
		for (const chatId of chatIds) {
			await (archived ? archiveChat(chatId) : unarchiveChat(chatId));
			store.updateChatListItem(chatId, { archived });
			if (useChatStore.getState().chatId === chatId) store.setChatArchived(archived);
			done++;
			update?.(progressMessage(done, chatIds.length, action));
		}
	};
	try {
		if (chatIds.length === 1) await archiveEach();
		else await withLoadingToast(progressMessage(0, chatIds.length, action), archiveEach);
	} catch (err) {
		useToastStore.getState().show({
			type: "error",
			message:
				chatIds.length === 1
					? `チャットの${action}に失敗しました。`
					: `チャットの${action}に失敗しました (${chatIds.length} 件中 ${done} 件は完了)。`,
		});
		throw err;
	}
	useToastStore.getState().show({
		type: "success",
		message:
			chatIds.length === 1
				? archived
					? "チャットをアーカイブしました。"
					: "チャットのアーカイブを解除しました。"
				: `${chatIds.length} 件のチャットを${action}しました。`,
	});
}

function progressMessage(done: number, total: number, action: string): string {
	return `${done}/${total} 件を${action}中…`;
}
